<template>
  <div>
    <el-dialog
      v-if="roleDialogVisible"
      v-dialogStyle
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="50%"
      class="role_dialog"
      :destroy-on-close="true"
      @close="roleDialogClose"
    >
      <el-table
        ref="roleTable"
        v-loading="loading"
        element-loading-text="加载数据中..."
        :data="tableData"
        height="50vh"
        max-height="50vh"
        border
        stripe
        highlight-current-row
        style="width: 100%; overflow-y: auto;"
        :row-style="{height:'38px'}"
        :cell-style="{padding:'0px'}"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="roleCode" label="角色编码" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="roleName" label="角色名称" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="position:sticky">
        <el-button @click="roleDialogClose()">取 消</el-button>
        <el-button type="primary" @click="bindOk()" v-preventReClick>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import '../taskProcess/dialogStyle.js'
export default {
  name: 'bindRoleDialog',
  props: {
    roleDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      loading: false,
      tableData: [],
      templateRole: {}
    }
  },
  watch: {
    roleDialogVisible(newValue, oldValue) {
      this.dialogVisible = newValue
    }
  },
  mounted() {
    //this.getRoleList()
  },
  methods: {

    getRoleList(row) {
      this.dialogTitle = '模板【' + row.name + '】' + '绑定角色'
      const that = this
      const data = {
        templateRoleId: row.templateRoleId
      }
      this.templateRole = {
        id: row.templateRoleId,
        templateGroupId: row.groupId,
        templateName: row.name,
        oldRoleIds: row.roleIds
      }
      this.loading = true
      this.$post('/fesback/templateBind/getBindRoleList.z', data).then(response => {
        if (response.success) {
          this.tableData = response.data
          if (row.templateRoleId) {
            this.$nextTick(() => {
              this.tableData.forEach(r => {
                if (row.roleIds.indexOf(r.modelID) !== -1) {
                  this.$refs.roleTable.toggleRowSelection(r, true)
                }
              })
            })
          }
        }
        this.loading = false
      }).catch(function(error) {
        that.loading = false
        that.$messageInfo('error', '系统异常：' + error)
      })
    },
    //确定
    bindOk() {
      const roles = this.$refs.roleTable.selection
      const roleIds = []
      const roleNames = []
      roles.forEach(role => {
        roleIds.push(role.modelID)
        roleNames.push(role.roleName)
      })
      this.templateRole.roleIds = roleIds.join(',')
      this.templateRole.roleNames = roleNames.join(',')
      let msg = '确定为模板【' + this.templateRole.templateName + '】绑定角色【' + this.templateRole.roleNames + '】？'
      if (roles.length === 0) {
        if (this.templateRole.id) {
          msg = '确定将模板【' + this.templateRole.templateName + '】已绑定的角色解绑掉？'
        } else {
          this.$messageInfo('info', '未选择要绑定的角色')
          return
        }
      }
      if (this.templateRole.roleIds === this.templateRole.oldRoleIds) {
        this.$messageInfo('info', '绑定的角色未发生变化')
        return
      }
      this.$confirmInfo(msg, 'info').then(res => {
        const that = this
        const url = '/fesback/templateBind/templateBindRoleSave.z'
        //请求后台
        this.$post(url, this.templateRole).then(response => {
          if (response.success) {
            that.$messageInfo('success', response.message)
            //刷新数据
            this.$parent.getList()
            this.clearDialog()
          } else {
            that.$messageInfo('error', response.message)
          }

        }).catch(function(error) {
          that.$messageInfo('error', '系统异常：' + error)
        })
      }).catch(err => {
        this.$messageInfo('info', '取消操作')
      })
    },
    roleDialogClose() {
      this.$emit('roleDialogClose')
      this.clearDialog()
    },
    clearDialog() {
      this.dialogVisible = false
      this.roleFilterText = ''
      this.templateRole = {}
      this.tableData = []
    }
  }
}

</script>

<style scoped>
/*更改字号*/
.el-table {
  font-size: 12px;
  color: #606266;
}
.span-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.role_dialog{
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}
/*缩小表格间距*/
.el-table ::v-deep.cell {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space:nowrap;
  word-break: break-all;
  line-height: 12px;
  padding-right: 10px;
}
.el-table th>.cell{
  display: inline-block;
  white-space: nowrap;
  word-break: keep-all;
  text-overflow: unset;
}
</style>
